export default __webpack_public_path__ + "static/media/use.1b94c054.svg";